export const CREATEUSER_INT_ADMIN = 'admin_intern'
export const CREATEUSER_INT = 'interne'
export const CREATEUSER_CLIENT = 'client'
export const CREATEUSER_SUPER_ADMIN = 'admin_totale'
export const CREATEUSER_CLIENT_ADMIN = 'admin_client'
export const ADMIN_CLIENT_INTERNE = 'admin_client_intern'
export const SUPPORT_N1 = 'admin_support_n1'

export const StatusOptions = [
  {
    value: 'beingCreated',
    label: 'En cours de création',
  },
  {
    value: 'activated',
    label: 'Actif',
  },
  {
    value: 'deactivated',
    label: 'Inactif',
  },
  {
    value: 'blocked',
    label: 'Bloqué',
  },
  {
    value: 'toDelete',
    label: 'Supprimé',
  },
]

export const DEFAULT_USERINFOS = {
  id: '',
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  type: '',
  fonction: '',
  roles: [''],
  UPN: '',
  officePhone: '',
  mobilePhone: '',
  createdAt: new Date(),
  state: '',
  lastConnexionDate: new Date(),
  passwordExpirationDate: new Date(),
  organizations: [],
  compagny: '',
  companyId: '',
  preferences: {
    phone: false,
    email: true,
    sms: false,
  },
  accessDemands: false,
  accessDocs: false,
  isSuperAdminTech: false,
}

export const DEFAULT_USER_SIGNUP_INFOS = {
  email: '',
  numDebiteur: '',
  numFacture: '',
  firstname: '',
  lastname: '',
  fonction: '',
  officePhone: '',
  mobilePhone: '',
  allowedAdministrator: false,
}
